import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Switch from 'flarum/common/components/Switch';
import UserBadge from '../../common/components/UserBadge';
import categorizeUserBadges from '../utils/categorizeUserBadges';
import Tooltip from 'flarum/common/components/Tooltip';
export default class SelectUserCardBadgesModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.limit = app.forum.attribute('numberOfBadgesOnUserCard');
    this.selectedBadges = this.attrs.user.userBadges().filter(userBadge => userBadge.inUserCard()).map(userBadge => userBadge.id());
  }
  className() {
    return 'Modal--big UserCardBadgesModal';
  }
  title() {
    return app.translator.trans('v17development-flarum-badges.forum.badges_in_card.title');
  }
  content() {
    return m("div", null, m("div", {
      className: "Modal-body"
    }, this.data().toArray()), m("div", {
      className: "Modal-footer"
    }, m(Button, {
      className: 'Button Button--primary',
      onclick: () => this.save(),
      loading: this.loading
    }, app.translator.trans('v17development-flarum-badges.forum.save_changes'))));
  }
  data() {
    const items = new ItemList();
    const categories = categorizeUserBadges(this.attrs.user);

    // Badge name
    items.add('info', m("div", {
      className: 'BadgeModalListItem'
    }, m("p", null, app.translator.trans('v17development-flarum-badges.forum.badges_in_card.description')), m("p", null, app.translator.trans('v17development-flarum-badges.forum.badges_in_card.select_limit', {
      limit: app.forum.attribute('numberOfBadgesOnUserCard'),
      b: m("b", null)
    }))));

    // Loop through all badge categories
    categories.map(({
      name,
      category,
      badges
    }) => {
      items.add(`badge_category_${category ? category.id() : 'uncategorized'}`, m("div", {
        className: 'UserCardBadgesModalCategory'
      }, m("div", {
        className: 'UserCardBadgesModalCategory-name'
      }, name), badges.sort((a, b) => a.badge().order() - b.badge().order()).map(userBadge => {
        const disabled = this.selectedBadges.length >= this.limit && this.selectedBadges.indexOf(userBadge.id()) === -1;
        return m(Tooltip, {
          text: disabled ? app.translator.trans('v17development-flarum-badges.forum.badges_in_card.hit_limit', {
            limit: app.forum.attribute('numberOfBadgesOnUserCard'),
            b: m("b", null)
          }) : '',
          position: "bottom"
        }, m("div", {
          className: 'UserCardBadgesModalCategory-badge',
          onclick: () => {
            if (disabled) {
              return;
            }
            const currentIndex = this.selectedBadges.indexOf(userBadge.id());

            // Remove from selected list
            if (currentIndex >= 0) {
              this.selectedBadges.splice(currentIndex, 1);
            } else {
              // Add to list
              this.selectedBadges.push(userBadge.id());
            }
          }
        }, m("div", {
          className: 'UserCardBadgesModalCategory-badge-preview'
        }, m(UserBadge, {
          badge: userBadge.badge(),
          onclick: () => {}
        })), m("div", {
          className: 'UserCardBadgesModalCategory-badge-switch'
        }, Switch.component({
          state: this.selectedBadges.indexOf(userBadge.id()) >= 0,
          disabled
        }))));
      })));
    });
    return items;
  }
  save() {
    this.loading = true;
    this.attrs.user.save({
      userCardBadges: this.selectedBadges
    }).then(() => {
      // Update current user badges store
      this.attrs.user.userBadges().map(userBadge => {
        userBadge.pushAttributes({
          inUserCard: this.selectedBadges.indexOf(userBadge.id()) >= 0
        });
      });
      this.hide();
    }).catch(() => {}).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('v17development-user-badges', 'forum/components/SelectUserCardBadgesModal', SelectUserCardBadgesModal);